import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles()((theme, { loading }) => ({
  roleSelection: {
    height: `100vh`,
    maxWidth: 500,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    margin: "auto",
  },
  roleOption: {
    textAlign: "center",
    padding: theme.spacing(2),
    "&:hover": {
      cursor: loading ? "progress" : "pointer",
      opacity: loading ? 1 : 0.8,
    },
  },
  roleOptionImage: {
    [theme.breakpoints.up("md")]: {
      maxHeight: 200,
    },
    width: "100%",
    maxHeight: 125,
    marginBottom: theme.spacing(2),
  },
  button: {
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(2),
    },
    position: "relative",
  },
  roleOptionButton: {
    minWidth: 200,
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function RoleSelection({
  t,
  roleOptions,
  selectedRole,
  setSelectedRole,
  handleNextStep,
  handleSelectRole,
  preferred_username,
}) {
  const [loading, setLoading] = useState(false);
  const { classes } = useStyles({ loading });
  const handleSelect = async (role) => {
    try {
      setLoading(true);
      setSelectedRole(role);
      await handleSelectRole(role);
      handleNextStep();
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className={classes.roleSelection}>
        <Typography variant='h5' gutterBottom color='textSecondary'>
          {preferred_username}
        </Typography>
        <Typography variant='h5' gutterBottom>
          {t("what_would_you_like_to_do")}
        </Typography>
        <br />
        <Grid container sx={{ width: "100%" }} spacing={2}>
          {roleOptions.map((option, idx) => (
            <Grid
              key={`roleoption_${idx}`}
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <div
                className={classes.roleOption}
                onClick={() => !loading && handleSelect(option.role)}
              >
                <img
                  className={classes.roleOptionImage}
                  src={option.img}
                  alt={option.role}
                />
                <div className={classes.button}>
                  <Button
                    variant='outlined'
                    color='primary'
                    className={classes.roleOptionButton}
                    disabled={loading}
                  >
                    {t(option.role)}
                  </Button>
                  {loading && selectedRole === option.role && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
}

export default RoleSelection;
